import { Component, Vue, Prop } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
let id: any = 0
import VisitorApi from '@/api/visitor'
import AreaApi from '@/api/area'
import { checkCarNo, hasVisitor, debounce } from '@/utils/util'
import { caseNoReg, taskRequest, contactPhonePattern } from '@/utils/regExp'
import isEmpty from 'lodash/isEmpty'
import { nameLength } from '@/config/global'
import SprFestModal from '@/components/Modal/SprFestModal.vue'

const debounceSearch = debounce(300)

@Component({
	components: {
		SprFestModal,
	},
})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public areaName: string = ''
	public areaData: any = ''
	public resurvey: boolean = false
	public taskType: any = ''
	public nameLength: any = nameLength
	public taskRequest: any = taskRequest
	public contactPhonePattern: any = contactPhonePattern
	public caseNoReg: any = caseNoReg
	public hasVisitor: any = hasVisitor

	public caseWaring: '' | 'warning' | 'success' | 'error' | 'validating' = ''
	public caseHelpMes = ''

	@Prop()
	public data!: any

	@Prop()
	public resurveyOrder!: any

	public activated() {}

	public get isResurveyOrder() {
		return !!this.resurveyOrder
	}

	public beforeSubmit(values: any) {
		return values
	}

	public prevStep() {
		this.$emit('prevStep')
	}

	public onCheckUrgent(e: Event) {
		const target = e.target as any
		this.addForm.setFieldsValue({
			urgentTask: target.checked ? '1' : '0',
		})
	}

	public async handleResurvey() {
		const res = await TaskApi.getOrderExStatusInfo(this.resurveyOrder.orderId)
		const data = res.data

		this.$nextTick(() => {
			this.areaData = {
				cityCode: data.cityCode,
				areaCode: data.countryCode,
			}

			const fields: any = {
				department: data.department,
				injuredName: data.injuredName,
				caseNo: data.caseNo,
				carNo: data.carNo,
			}
			this.addForm.setFieldsValue(fields)
			if (data.hospital) {
				fields.hospital = {
					label: data.hospital,
					key: data.longitude + '-' + data.latitude,
				}
			}
			if (data.clinicArea) {
				fields.code = {
					key: [data.provinceCode, data.cityCode, data.countryCode].join('-'),
					label: data.clinicArea,
				}
			}
			if (data.carNo === '无牌') {
				this.onHasCarNoChange({
					target: {
						checked: true,
					},
				})
			} else {
				fields.carNo = data.carNo
			}
			fields.ownerName = data.ownerName
			fields.ownerPhone = data.ownerPhone

			this.addForm.setFieldsValue(fields)
			if (data.injuredPhone) {
				const phones = data.injuredPhone.split(',')
				const ids: any = []
				const phoneArr: any = []
				this.phoneId = 0
				for (const p of phones) {
					ids.push(this.phoneId)
					phoneArr[this.phoneId] = p
					this.phoneId++
				}
				this.addForm.setFieldsValue({
					injuredPhone: ids,
				})
				this.$nextTick(() => {
					this.addForm.setFieldsValue({
						injuredPhoneArray: phoneArr,
					})
				})
			}
		})
	}

	public created() {
		this.addForm = this.$form.createForm(this)
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.getFieldDecorator('injuredPhone', {
			initialValue: [id],
			preserve: true,
		})
		this.addForm.getFieldDecorator('urgentTask', { preserve: true })
		if (this.resurveyOrder) {
			this.handleResurvey()
		}

		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
	}

	public checkCaseNo(rule: any, value: any, callback: Function) {
		var reg = /^[^\u4e00-\u9fa5]+$/
		if (!!value && !reg.test(value)) {
			this.caseWaring = 'error'
			this.caseHelpMes = '不能输入中文字符'
			return
		}
		this.caseWaring = 'warning'
		this.caseHelpMes = '注: 如非本地承保案件，委派前建议先获取承保机构同意'
		console.log('注: 如非本地承保案件，委派前建议先获取承保机构同意')
		return callback()
	}

	public onHospitalSelect(res: any) {
		this.$nextTick(() => {
			this.addForm.setFieldsValue({
				hospital: {
					label: res.title,
					key: res.point.lng + '-' + res.point.lat,
				},
			})
		})
	}

	public onAreaSelect(res: any) {
		const code = res.code.split('-')
		this.areaData = {
			cityCode: code[1],
			areaCode: code[2],
		}
		this.searchHospital = []
	}

	public onIsInjuredChange(e: any) {
		this.isInjured = e.target.checked

		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredName: this.addForm.getFieldValue('ownerName'),
				injuredPhoneArray,
			})
		}
	}

	public onOwnerNameInput(e: any) {
		if (this.isInjured) {
			this.addForm.setFieldsValue({
				injuredName: e.target.value,
			})
		}
	}

	public onOwnerPhoneInput(e: any) {
		if (this.isInjured) {
			const injuredPhone = this.addForm.getFieldValue('injuredPhone')
			const firstPhoneId = injuredPhone[0]
			const injuredPhoneArray = this.addForm.getFieldValue('injuredPhoneArray')
			const phone = this.addForm.getFieldValue('ownerPhone')
			injuredPhoneArray[firstPhoneId] = phone

			this.addForm.setFieldsValue({
				injuredPhoneArray,
			})
		}
	}

	public onHasCarNoChange(e: any) {
		this.hasNoCarNo = e.target.checked
		this.addForm.setFieldsValue({
			carNo: e.target.checked ? '无牌' : '',
		})
	}

	public setPublisher() {
		this.$nextTick(() => {
			if (this.sameWithPublisher) {
				this.addForm.setFieldsValue({
					contact: this.$store.state.user.userInfo.name,
					contactPhone: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.addForm.setFieldsValue({
					contact: undefined,
					contactPhone: undefined,
				})
			}
		})
	}

	public onWithPublisherChange(e: any) {
		this.sameWithPublisher = e.target.checked
		this.setPublisher()
	}

	/*就诊地区输入搜索*/
	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public removePhone(k: any) {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		// We need at least one passenger
		if (injuredPhone.length === 1) {
			return
		}

		// can use data-binding to set
		this.addForm.setFieldsValue({
			injuredPhone: injuredPhone.filter((key: any) => key !== k),
		})
	}

	public addPhone() {
		// can use data-binding to get
		const injuredPhone = this.addForm.getFieldValue('injuredPhone')
		const nextPhone = injuredPhone.concat(++id)
		// can use data-binding to set
		// important! notify form to detect changes
		this.addForm.setFieldsValue({
			injuredPhone: nextPhone,
		})
	}

	public afterAdd() {}

	public resetPage() {
		this.sameWithPublisher = true
		this.setPublisher()
		this.addForm.resetFields()
	}

	public checkCarNo(rule: string, value: string, cb: any) {
		const carNo = value && value.toUpperCase()
		if (value !== carNo) {
			this.addForm.setFieldsValue({
				carNo,
			})
			this.addForm.validateFields(['carNo'])
		}

		if (!carNo) {
			cb(new Error('请输入标的车牌号'))
		} else if (carNo === '无牌') {
			cb()
		} else if (!checkCarNo(carNo)) {
			cb(new Error('请输入正确的标的车牌号'))
		} else {
			cb()
		}
	}

	public onOk() {
		this.$emit('ok')
		this.sameWithPublisher = true
		this.setPublisher()
		this.afterAdd()
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open('/AiiTasks/TasksList')
	}
}
